<template>
	<div class="">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="layout m-fzdsj">
			<div class="dsj_count no-padding-top">
				<div class="wow fadeInUp animated"  >
					<img class="list_img" :src="zidiyiData.great_age.files" />
				</div>
				<div class="dsj_info">
					<div class="info_tit wow fadeInUp animated" >
						<div class="tit_left">
							<span>发展大事记</span>
							<el-divider direction="vertical"></el-divider>
							<span>DEVELOPMENT OF MEMORABILIA</span>
						</div>
					</div>
					<!-- 列表 -->
					<div class="dsj_list">
						<div class="dsj_list_tit wow fadeInUp animated" >
							<img class="xiangzuo" @click="next_you(index1)" src="@/assets/img/zuo.png" />
							<div class="time_list wow fadeInUp animated" >
								<span class="css3" v-for="(item,index) in dataList" @click.stop="choose_year(index)"
									:class="index==index1 ? 'tit_active' : ''">
									{{index}}
								</span>
							</div>
							<img class="xiangzuo" @click="next_zuo(index1)" src="@/assets/img/you.png" />
						</div>
						<div class="dsj_list_count wow fadeInUp animated" >
							<div class="count_info" v-for="(item,index) in dataList[index1]" @click="opetime(index)">
								<div class="info_lineone">
									<span :class="monthIndex==index ? 'active1' : ''"></span>
									<span :class="monthIndex==index ? 'active2' : ''">{{item.date2}}</span>
									<span class="text-uppercase">{{item.date3}}</span>
								</div>
								<div class="info_linetwo">
									<span></span>
									<span :class="monthIndex==index ? 'active3' : ''">{{lang=='CN' ? item.cn_text : item.en_text}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {channel_list,add_pv,get_banner,get_file_all,history_lst} from '@/api/api.js'
	import {WOW} from 'wowjs'
	export default {
		components: {Header,Footer},
		name: 'fzmemorabilia',
		data() {
			return {
				currentPage4: 1,
				timeList: [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012, 2011],
				index1: 0, //时间下标
				dataList: [],
				dataListStr: [],
				parent_id: 13,
				list: [], //
				max: '', //最大
				min: '', //最小
				jx_index: '',
				per_page: 9,
				zidiyiData: {
					great_age: {
						files: ''
					}
				},
				page: 1,
				arcList: [], //内容列表
				content: {}, //内容详情
				total: '',
				company_id: 1, //公司ID
				banner: '',
				monthIndex: 0, //
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			this.parent_id = this.$route.query.parent_id
			this.getZidiyiData() //自定义图片
			this.getBanner();
			this.addLocatPath()
			this.getData()
			localStorage.setItem('current', 5)
			let data = {
				parent_id: this.parent_id
			}
			channel_list(data).then((res) => {
				if (res.code == 1) {
					this.list = res.data
					if (res.data) {
						this.jx_index = this.list[this.index].id
						this.getArchivesList(res.data[0].id)
					}
				}
			}).catch(err => {});
			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {

		},
		methods: {
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},
			addLocatPath() {
				let data = {
					directions: '发展大事纪',
					path: window.location.href
				}
				add_pv(data).then((res) => {}).catch(err => {});
			},
			getBanner() {
				let data = {
					company_id: this.company_id,
					tag: '集团概况'
				}
				get_banner(data).then((res) => {
					if (res.code == 1) {
						this.banner = res.data
					}
				}).catch(err => {});
			},
			getChannelList() {
				let data = {
					parent_id: this.parent_id
				}
				channel_list(data).then((res) => {
					if (res.code == 1) {
						this.list = res.data
					}
				}).catch(err => {});
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				get_file_all(data).then((res) => {
					this.zidiyiData = res.data
				}).catch(err => {});
			},
			getData() {
				let data = {
					company_id: 1
				}
				history_lst(data).then((res) => {
					if (res.code == 1) {
						this.dataList = res.data
						if (this.dataList) {
							this.index1 = Object.keys(this.dataList)[0]
							this.dataListStr = Object.keys(this.dataList)
							this.min = Object.keys(this.dataList)[0]
							this.max = Object.keys(this.dataList)[Object.keys(this.dataList).length - 1]
							this.index1 = this.max
						}
					}
				}).catch(err => {});
			},
			opetime(num) {
				this.monthIndex = num
			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
			},
			next_zuo(num) {
				if (parseInt(this.index1) > parseInt(this.min)) {
					this.index1 = Object.keys(this.dataList)[this.dataListStr.indexOf(this.index1) - 1]
				}
			},
			next_you(num) {
				if (parseInt(this.index1) < parseInt(this.max)) {
					this.index1 = Object.keys(this.dataList)[this.dataListStr.indexOf(this.index1) + 1]
				}
			},
			choose_year(num) {
				this.index1 = num
			}
		}
	}
</script>

<style lang="scss" scoped>
	.col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.m-fzdsj {
		background: #fff;

		.dsj_count {
			padding: 30px;
		}

		.dsj_info {
			margin: 50px auto;
			max-width: 1400px;
		}

		.dsj_count {
			.list_img {
				width: 100%;
			}
		}

		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;

			.active {
				border: 2px solid #006170;
				box-shadow: 5px 7px 10px #cddadc;
				color: #000;
			}
		}

		.tit_left {
			span:first-child {
				font-size: 30px;
				color: #000;
				font-weight: bold;
			}

			span:last-child {
				font-size: 12px;
				color: #999;
			}

		}

		.dsj_list {
			margin-top: 30px;

			.dsj_list_tit {
				display: flex;
				align-items: center;

				.time_list {
					background: #f0f4f5;
					padding: 0 30px;
					height: 60px;
					line-height: 60px;
					display: flex;
					flex-direction: row-reverse;

					span {
						display: block;
						width: 60px;
						text-align: center;
						margin-right: 30px;
						font-size: 16px;
						color: #666;
						cursor: pointer;
					}

					img {
						width: 60px;
						height: 60px;
						cursor: pointer;

					}
					.tit_active {
						background: #006170;
						color: #fff;
						height: 65px;
						box-shadow: 8px 8px 8px #cddadc;
					}

					span:hover {
						color: #006170;
					}
				}


			}


			.dsj_list_count {

				margin-top: 100px;
				min-height: 300px;
			}

			.info_lineone {
				display: flex;
				align-items: center;

				span:nth-child(1) {
					width: 10px;
					height: 10px;
					border-radius: 50px;
					border: 2px solid #006170;
				}

				span:nth-child(2) {
					font-size: 16px;
					color: #000;
					font-weight: bold;
					margin-left: 50px;
				}
			}

			.info_linetwo {
				display: flex;
				margin-top: 5px;

				span:nth-child(1) {
					width: 2px;
					height: 100px;
					background: #CCDFE2;
					display: block;
					margin-left: 4px;
				}

				span:nth-child(2) {
					padding: 20px;
					background: #f0f4f5;
					line-height: 36px;
					color: #000;
					margin: 10px 0 20px 50px;
				}


			}

		}
	}

	.xiangzuo:hover {
		opacity: 0.8;
	}

	.m-fzdsj .count_info:last-child .info_linetwo span:first-child {
		display: none;
	}

	.m-fzdsj .count_info:last-child .info_linetwo span:last-child {
		margin-left: 55px;
	}

	.m-fzdsj .active1 {
		width: 15px !important;
		height: 15px !important;
		background: #006170;
		margin-left: -2px;
	}

	.m-fzdsj .active2 {
		color: #006170 !important;
		margin-left: 48px !important;
	}

	.m-fzdsj .active3 {
		background: #fff !important;
		border: 1px solid #006170;
		box-shadow: 5px 5px 15px #cddadc;
	}

	@media screen and (max-width: 768px) {
		.m-fzdsj .dsj_info {
			width: 100%;
		}

		.m-fzdsj .dsj_list_tit {
			overflow: auto;
		}
	}
</style>
